import { Control, UseFormGetValues } from 'react-hook-form';
import { ServiceFeeSchemaType } from '../../ServiceFee/ServiceFeeSettings';
import { ServiceFeeSettingsFormData } from '../../ServiceFee/ServiceFeeSettings';
import PercentageSchema from './PercentageSchema';
import RegularSchema from './RegularSchema';
import SpecialSchema from './SpecialSchema';
import TierSchema from './TierSchema';

type ServiceFeeSchemaTableProps = {
	schemeType: ServiceFeeSchemaType;
	tierCount: ServiceFeeSettingsFormData['tier_count'];
	control: Control<ServiceFeeSettingsFormData>;
	withNonShareableAmount: ServiceFeeSettingsFormData['with_non_shareable_amount'];
	serviceFeeBillingType: ServiceFeeSettingsFormData['billing_type'];
	action?: string;
	getValues?: UseFormGetValues<ServiceFeeSettingsFormData>;
	modalIsOpen?:boolean
};

const ServiceFeeSchemaTable: React.FC<ServiceFeeSchemaTableProps> = ({
	schemeType,
	tierCount,
	control,
	withNonShareableAmount,
	serviceFeeBillingType,
	modalIsOpen,
	...props
}) => {
	switch (schemeType) {
		case 'REGULAR':
			return (
				<RegularSchema
					control={control}
					serviceFeeBillingType={serviceFeeBillingType}
					withNonShareableAmount={withNonShareableAmount}
					modalIsOpen={modalIsOpen}
					{...props}
				/>
			);
		case 'TIER':
			return (
				<TierSchema
					control={control}
					serviceFeeBillingType={serviceFeeBillingType}
					withNonShareableAmount={withNonShareableAmount}
					tierCount={tierCount}
					modalIsOpen={modalIsOpen}
					{...props}
				/>
			);
		case 'PERCENTAGE':
			return (
				<PercentageSchema
					control={control}
					serviceFeeBillingType={serviceFeeBillingType}
					withNonShareableAmount={withNonShareableAmount}
					modalIsOpen={modalIsOpen}
					{...props}
				/>
			);
		case 'SPECIAL':
			return (
				<SpecialSchema
					control={control}
					serviceFeeBillingType={serviceFeeBillingType}
					withNonShareableAmount={withNonShareableAmount}
					modalIsOpen={modalIsOpen}
					{...props}
				/>
			);
		default:
			return <></>;
	}
};
//
export default ServiceFeeSchemaTable;
